import { ToastAlertVariants } from '../ToastContext';

export const ToastAlertTitles: Record<ToastAlertVariants, string> = {
  [ToastAlertVariants.success]: 'Success',
  [ToastAlertVariants.error]: 'Failed',
  [ToastAlertVariants.info]: 'Info',
};
